import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import Header from '../../containers/Editor/Header';
import Thumbnails from '../../containers/Editor/Thumbnails';
import ThumbnailsToggle from '../../containers/Editor/ThumbnailsToggle';
import Page from '../../containers/Editor/Page';
import PreviewPage from '../../containers/Editor/PreviewPage';
import PageTitle from '../../containers/Editor/PageTitle';
import {
	EditorContainer,
	EditorWrapper,
	ContentWrapper,
	ContentInner,
	PageWrapper,
	Loader,
} from './styles';
import { getData, reset } from '../../containers/Editor/actions';
import { EditorType } from '../../containers/Editor/constants';
import { updateDriveItem } from '../../containers/DriveItemList/actions';
import { StoreState } from '../../reducers';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import ApiUtils from '../../utils/api';

interface EditorProps {
	type: EditorType;
	clientId: number;
	resourceId: number;
	isEditorLoaded: boolean;
	isPreviewPage: boolean;
	isCombining: boolean;
	comboPercentage: number;
	dispatch: Dispatch<StoreState>;
}

const Editor = ({
	type,
	clientId,
	resourceId,
	isEditorLoaded,
	isPreviewPage,
	isCombining,
	comboPercentage,
	dispatch,
}: EditorProps) => {
	const container = React.useRef<HTMLDivElement>(null);
	// need for resource refresh if it was previously downloaded
	const updateResourceMeta = async () => {
		const resource = await ApiUtils.getMeta(resourceId, true, true);
		dispatch(updateDriveItem(resource));
	};

	React.useEffect(() => {
		dispatch(getData(clientId, resourceId));

		return () => {
			dispatch(reset());
			updateResourceMeta();
		};
	}, [clientId, resourceId]);

	return (
		<EditorContainer ref={container}>
			<Header isEditorLoaded={isEditorLoaded} />
			<EditorWrapper>
				{isEditorLoaded
					? (
						<>
							{isCombining &&
								<Loader isCombo={true}>
									{Utils.getSvgIcon('iconset_loading')}
									<Translate
										value="messages.combining"
										percentage={comboPercentage.toString()}
									/>
								</Loader>
							}
							{type === EditorType.INDESIGN && <Thumbnails />}
							<ContentWrapper>
								<ContentInner>
									{type === EditorType.INDESIGN && <ThumbnailsToggle />}
									<PageWrapper isMobileApp={UserAgentUtils.isMobileApp}>
										{isPreviewPage && <PreviewPage />}
										<Page
											isHidden={isPreviewPage}
											editorContainer={container.current}
										/>
									</PageWrapper>
								</ContentInner>
								<PageTitle />
							</ContentWrapper>
						</>
					)
					: (
						<Loader>
							{Utils.getSvgIcon('iconset_loading')}
							<Translate value="messages.loading" />
						</Loader>
					)
				}
			</EditorWrapper>
		</EditorContainer>
	);
};

export default Editor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/index.tsx